import React from 'react';
import './RouterTransition.scss';
import {
  Redirect,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';
import {
  TransitionGroup,
  CSSTransition,
} from 'react-transition-group';
import Landing from './Landing';
import List from './List';
import Active from './Active';

function RouterTransition(): JSX.Element {
  const location = useLocation();
  return (
    <TransitionGroup className="transition-group">
      <CSSTransition
        key={location.key}
        timeout={700}
        classNames="page-node"
      >
        <Switch location={location}>
          <Route path="/landing" component={Landing} />
          <Route path="/list" component={List} />
          <Route path="/active" component={Active} />
          <Redirect path="*" to="/landing" />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  );
}

export default RouterTransition;
